import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../context/LanguageContext';
import { localizedPath } from '../utils/routes';

const BASE_URL = 'https://www.mecaniqueautocjpa.com';

export default function SEOHead({ page }) {
  const { t, language } = useLanguage();
  const seo = t.seo?.[page];
  if (!seo) return null;

  const { title, description, path, routeName, noindex } = seo;
  const canonical = `${BASE_URL}${path}`;

  // Build hreflang alternate URLs
  const frUrl = routeName ? `${BASE_URL}${localizedPath(routeName, 'fr')}` : null;
  const enUrl = routeName ? `${BASE_URL}${localizedPath(routeName, 'en')}` : null;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {frUrl && <link rel="alternate" hreflang="fr" href={frUrl} />}
      {enUrl && <link rel="alternate" hreflang="en" href={enUrl} />}
      {frUrl && <link rel="alternate" hreflang="x-default" href={frUrl} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={t.seo?._locale || 'fr_CA'} />
      <meta property="og:locale:alternate" content={language === 'fr' ? 'en_CA' : 'fr_CA'} />
      <meta property="og:image" content={`${BASE_URL}/images/og/og-image-cjpa.jpg`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
    </Helmet>
  );
}
